import { render } from "./shop-sidebar-area.vue?vue&type=template&id=9d061b4c&scoped=true"
import script from "./shop-sidebar-area.vue?vue&type=script&lang=js"
export * from "./shop-sidebar-area.vue?vue&type=script&lang=js"

import "./shop-sidebar-area.vue?vue&type=style&index=0&id=9d061b4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d061b4c"]])

export default __exports__